import { Config } from './config.model';

export const environment: Config = {
  production: false,
  name: 'pdn.dev',
  urlAuthorityAM: 'https://lobbycloudgate.amx-digital.com',
  clientIdAM: 'cGnh421MUYfah218iBsCQGgN2IpM8H9n',
  AudienceAM: 'https://dev-tp-travel-aud/',
  IDPScopeAM: 'openid profile email',
  urlEnvRedirectAM: 'https://web-ui.tptravel.dev.ontp.app:8089/integrations',
  auth0SkipRedirectCallbackURL: '/integrations',
  auth0UFederated: false,
  auth0UReturnTo: 'https://web-ui.tptravel.dev.ontp.app:8089/end-process'
} as Config;
